import { useErrorCodeTranslation } from '@hooks';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BottomSheet from './BottomSheet';
import Button from './Button';

export default function DeleteErrorBottomSheet({
  isOpen,
  onClose,
  error
}: {
  isOpen: boolean;
  onClose: () => void;
  error;
}) {
  const { t } = useTranslation();
  const { translate } = useErrorCodeTranslation();

  const errorTranslation = useMemo(() => {
    return translate(error);
  }, [error]);

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} desktopVersion='modal'>
      <div className='flex flex-col items-center gap-md py-lg px-md dk:w-[400px] mx-auto'>
        <div className={classNames('H5 text-center', setupForDark('text-primary'))}>
          {errorTranslation.header}
        </div>
        <div className={classNames('P2R text-center', setupForDark('text-secondary'))}>
          {errorTranslation.text}
        </div>
        <div className={classNames('flex flex-row mx-auto gap-sm w-full')}>
          <Button onClick={onClose} type='tertiary' size='large' fullWidth>
            {t('components.deleteErrorBottomSheet.acknowledgeButton')}
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
}
